<app-add-form
  data-testid="purchase-order-edit-form"
  #addForm
  [title]="'purchase_order.edit.title' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="loading()"
  [initialData]="currentFormData"
  [editMode]="true"
  [getFieldError]="getDetailFieldError.bind(this)"
  (formAction)="onFormAction($event.action)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
>
  <!-- Actions Template for Detail Items -->
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      @if (isNormalMode()) {
      <!-- Normal mode: only delete button -->
      <span
        [attr.data-testid]="'purchase-order-edit-action-delete-detail-' + rowData.id"
        (click)="onTableAction({ action: 'deleteDetail', data: rowData })"
        class="action-link action-delete cursor-pointer"
      >
        {{ "common.actions.delete" | translate }}
      </span>
      } @else {
      <!-- Purchase request mode: no actions (items are read-only) -->
      <span class="text-gray-400 text-sm">
        {{ "common.read_only" | translate }}
      </span>
      }
    </div>
  </ng-template>
</app-add-form>

<!-- Toast Messages -->
<p-toast data-testid="purchase-order-edit-toast"></p-toast>
